import React from "react";
import { FaAngleDoubleUp } from "react-icons/fa";
import { useGlobalContext } from "../context";

const ScrollButton = () => {
  const { height } = useGlobalContext();

  const scrollBackToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      onClick={scrollBackToTop}
      className={`scroll-btn ${height > 100 && "show-scroll-btn"}`}
    >
      <FaAngleDoubleUp></FaAngleDoubleUp>
    </button>
  );
};

export default ScrollButton;
